/**
 * @generated SignedSource<<7f5e86a929bcb0f73cbef905021d81bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "YEAR" | "MONTH" | "DAY" | "%future added value";
export type FinancialAggregatedNumber = "actualRevenue" | "billableActualTimeAndExpenses" | "nonBillableActualTimeAndExpenses" | "allActualTimeAndExpenses" | "actualCost" | "actualProfit" | "actualRevenueProfit" | "actualMargin" | "actualRevenueMargin" | "plannedRevenue" | "billablePlannedTimeAndExpenses" | "nonBillablePlannedTimeAndExpenses" | "allPlannedTimeAndExpenses" | "plannedCost" | "plannedProfit" | "plannedRevenueProfit" | "plannedMargin" | "plannedRevenueMargin" | "remainingRevenue" | "billableForecastTimeAndExpensesToComplete" | "nonBillableForecastTimeAndExpensesToComplete" | "allForecastTimeAndExpensesToComplete" | "remainingCost" | "forecastCostToComplete" | "remainingProfit" | "forecastProfitToComplete" | "forecastRevenueProfitToComplete" | "remainingMargin" | "forecastMarginToComplete" | "forecastRevenueMarginToComplete" | "forecastRevenue" | "billableTotalTimeAndExpensesAtCompletion" | "nonBillableTotalTimeAndExpensesAtCompletion" | "allTotalTimeAndExpensesAtCompletion" | "forecastCost" | "totalCostAtCompletion" | "forecastProfit" | "totalProfitAtCompletion" | "totalRevenueProfitAtCompletion" | "forecastMargin" | "totalMarginAtCompletion" | "totalRevenueMarginAtCompletion" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineCost" | "baselineProfit" | "baselineMargin" | "baselineVsActualRevenue" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualProfit" | "baselineVsActualMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueMargin" | "baselineVsForecastRevenue" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "baselineVsForecastCost" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsForecastProfit" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineMinutes" | "planVsActualRevenue" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsActualCost" | "planVsActualProfit" | "planVsActualMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueMargin" | "planVsForecastRevenue" | "planVsForecastCost" | "planVsForecastProfit" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "recognitionLockedRevenue" | "registeredMinutes" | "billableActualMinutes" | "nonBillableActualMinutes" | "remainingMinutes" | "forecastTimeToComplete" | "forecastMinutes" | "totalTimeAtCompletion" | "scopeApprovedMinutes" | "scopeTotalMinutes" | "allocationMinutes" | "invoiced" | "paid" | "accruedDeferred" | "baselineVsRegisteredMinutes" | "baselineVsForecastMinutes" | "baselineVsTotalTimeAtCompletion" | "registeredVsScopeApprovedMinutes" | "scopeApprovedVsRegisteredMinutes" | "forecastVsScopeApprovedMinutes" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "billableTime" | "recognitionPercentage" | "recognitionAmount" | "surplus" | "surplusPercentage" | "estimatedCost" | "recognitionProfit" | "recognitionProfitPercentage" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionForecastRevenue" | "totalRevenueRecognition" | "estimatedCostPercentage" | "expenseRevenuePercentage" | "expenseCostPercentage" | "recognitionOpenRevenue" | "actualOpenRevenue" | "actualLockedRevenue" | "totalActualRevenueRecognition" | "forecastOpenRevenueToComplete" | "forecastLockedRevenueToComplete" | "totalForecastRevenueToComplete" | "suggestedRevenue" | "suggestedRevenuePercentage" | "suggestedProfit" | "suggestedProfitPercentage" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type DetailsExpenseCategoryLoader_Query$variables = {
  projectId: string;
  phaseId: string;
  startYear: number;
  startMonth: number;
  startDay: number;
  endYear: number;
  endMonth: number;
  endDay: number;
  aggregateLevel: AggregateLevel;
  aggregate: FinancialAggregatedNumber;
  searchQuery?: TaskSearchQueryType | null;
  baselineRevenue: boolean;
  baselineCost: boolean;
  baselineProfit: boolean;
  billableActualTimeAndExpenses: boolean;
  actualCost: boolean;
  actualProfit: boolean;
  billablePlannedTimeAndExpenses: boolean;
  plannedCost: boolean;
  plannedProfit: boolean;
  billableForecastTimeAndExpensesToComplete: boolean;
  forecastCostToComplete: boolean;
  forecastProfitToComplete: boolean;
  billableTotalTimeAndExpensesAtCompletion: boolean;
  totalCostAtCompletion: boolean;
  totalProfitAtCompletion: boolean;
  planVsBillableActualTimeAndExpenses: boolean;
  planVsActualCost: boolean;
  planVsActualProfit: boolean;
  planVsTotalBillableTimeAndExpensesAtCompletion: boolean;
  planVsTotalCostAtCompletion: boolean;
  planVsTotalProfitAtCompletion: boolean;
  baselineVsBillableActualTimeAndExpenses: boolean;
  baselineVsActualCost: boolean;
  baselineVsActualProfit: boolean;
  baselineVsBillableTotalTimeAndExpensesAtCompletion: boolean;
  baselineVsTotalCostAtCompletion: boolean;
  baselineVsTotalProfitAtCompletion: boolean;
  invoiced: boolean;
  paid: boolean;
  baselineMinutes: boolean;
  baselineVsRegisteredMinutes: boolean;
  baselineVsTotalTimeAtCompletion: boolean;
  registeredMinutes: boolean;
  scopeApprovedMinutes: boolean;
  registeredVsScopeApprovedMinutes: boolean;
  scopeApprovedVsRegisteredMinutes: boolean;
  forecastTimeToComplete: boolean;
  totalTimeAtCompletion: boolean;
  totalTimeAtCompletionVsScopeApprovedMinutes: boolean;
  scopeApprovedVsTotalTimeAtCompletion: boolean;
};
export type DetailsExpenseCategoryLoader_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"DetailsExpenseCategoryLoader_viewer">;
  } | null;
};
export type DetailsExpenseCategoryLoader_Query = {
  variables: DetailsExpenseCategoryLoader_Query$variables;
  response: DetailsExpenseCategoryLoader_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualCost"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualProfit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateLevel"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineCost"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineMinutes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineProfit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineRevenue"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualCost"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualProfit"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsBillableActualTimeAndExpenses"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsRegisteredMinutes"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalCostAtCompletion"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalProfitAtCompletion"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalTimeAtCompletion"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableActualTimeAndExpenses"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableForecastTimeAndExpensesToComplete"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billablePlannedTimeAndExpenses"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableTotalTimeAndExpensesAtCompletion"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastCostToComplete"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastProfitToComplete"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastTimeToComplete"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiced"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paid"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phaseId"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualCost"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualProfit"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsBillableActualTimeAndExpenses"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalBillableTimeAndExpensesAtCompletion"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalCostAtCompletion"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalProfitAtCompletion"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedCost"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedProfit"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registeredMinutes"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registeredVsScopeApprovedMinutes"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedMinutes"
},
v41 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedVsRegisteredMinutes"
},
v42 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedVsTotalTimeAtCompletion"
},
v43 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v44 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v45 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v46 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v47 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalCostAtCompletion"
},
v48 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalProfitAtCompletion"
},
v49 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalTimeAtCompletion"
},
v50 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalTimeAtCompletionVsScopeApprovedMinutes"
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "details_expense_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"details_expense_loader\")"
},
v53 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v54 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v55 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v56 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v57 = {
  "kind": "Variable",
  "name": "phaseId",
  "variableName": "phaseId"
},
v58 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v59 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v60 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v61 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v63 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v62/*: any*/)
],
v64 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v65 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseCategory",
  "kind": "LinkedField",
  "name": "expenseCategory",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsExpenseCategoryLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          (v52/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "actualCost",
                "variableName": "actualCost"
              },
              {
                "kind": "Variable",
                "name": "actualProfit",
                "variableName": "actualProfit"
              },
              {
                "kind": "Variable",
                "name": "aggregate",
                "variableName": "aggregate"
              },
              (v53/*: any*/),
              {
                "kind": "Variable",
                "name": "baselineCost",
                "variableName": "baselineCost"
              },
              {
                "kind": "Variable",
                "name": "baselineMinutes",
                "variableName": "baselineMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineProfit",
                "variableName": "baselineProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineRevenue",
                "variableName": "baselineRevenue"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualCost",
                "variableName": "baselineVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualProfit",
                "variableName": "baselineVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableActualTimeAndExpenses",
                "variableName": "baselineVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                "variableName": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsRegisteredMinutes",
                "variableName": "baselineVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalCostAtCompletion",
                "variableName": "baselineVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalProfitAtCompletion",
                "variableName": "baselineVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalTimeAtCompletion",
                "variableName": "baselineVsTotalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "billableActualTimeAndExpenses",
                "variableName": "billableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableForecastTimeAndExpensesToComplete",
                "variableName": "billableForecastTimeAndExpensesToComplete"
              },
              {
                "kind": "Variable",
                "name": "billablePlannedTimeAndExpenses",
                "variableName": "billablePlannedTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableTotalTimeAndExpensesAtCompletion",
                "variableName": "billableTotalTimeAndExpensesAtCompletion"
              },
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              {
                "kind": "Variable",
                "name": "forecastCostToComplete",
                "variableName": "forecastCostToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastProfitToComplete",
                "variableName": "forecastProfitToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastTimeToComplete",
                "variableName": "forecastTimeToComplete"
              },
              {
                "kind": "Variable",
                "name": "invoiced",
                "variableName": "invoiced"
              },
              {
                "kind": "Variable",
                "name": "paid",
                "variableName": "paid"
              },
              (v57/*: any*/),
              {
                "kind": "Variable",
                "name": "planVsActualCost",
                "variableName": "planVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "planVsActualProfit",
                "variableName": "planVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "planVsBillableActualTimeAndExpenses",
                "variableName": "planVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                "variableName": "planVsTotalBillableTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalCostAtCompletion",
                "variableName": "planVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalProfitAtCompletion",
                "variableName": "planVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "plannedCost",
                "variableName": "plannedCost"
              },
              {
                "kind": "Variable",
                "name": "plannedProfit",
                "variableName": "plannedProfit"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              {
                "kind": "Variable",
                "name": "registeredMinutes",
                "variableName": "registeredMinutes"
              },
              {
                "kind": "Variable",
                "name": "registeredVsScopeApprovedMinutes",
                "variableName": "registeredVsScopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedMinutes",
                "variableName": "scopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsRegisteredMinutes",
                "variableName": "scopeApprovedVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsTotalTimeAtCompletion",
                "variableName": "scopeApprovedVsTotalTimeAtCompletion"
              },
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              {
                "kind": "Variable",
                "name": "totalCostAtCompletion",
                "variableName": "totalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalProfitAtCompletion",
                "variableName": "totalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletion",
                "variableName": "totalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                "variableName": "totalTimeAtCompletionVsScopeApprovedMinutes"
              }
            ],
            "kind": "FragmentSpread",
            "name": "DetailsExpenseCategoryLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v37/*: any*/),
      (v28/*: any*/),
      (v46/*: any*/),
      (v45/*: any*/),
      (v44/*: any*/),
      (v22/*: any*/),
      (v21/*: any*/),
      (v20/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v43/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v16/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v18/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v17/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v19/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v31/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v38/*: any*/),
      (v40/*: any*/),
      (v39/*: any*/),
      (v41/*: any*/),
      (v25/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v42/*: any*/)
    ],
    "kind": "Operation",
    "name": "DetailsExpenseCategoryLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v51/*: any*/),
          (v52/*: any*/),
          (v62/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v63/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v63/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v64/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v65/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/)
                ],
                "concreteType": "ExpenseCategoryFinancialBreakdown",
                "kind": "LinkedField",
                "name": "expenseCategoryFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v66/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "baselineRevenue",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineRevenue",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billablePlannedTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billablePlannedTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableForecastTimeAndExpensesToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableForecastTimeAndExpensesToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastCostToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastCostToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastProfitToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastProfitToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalBillableTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "invoiced",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "paid",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paid",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastTimeToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastTimeToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletionVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v53/*: any*/),
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "aggregates.0",
                        "variableName": "aggregate"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "aggregates"
                  },
                  (v64/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v65/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/)
                ],
                "concreteType": "AggregatedExpenseCategoryFinancialBreakdown",
                "kind": "LinkedField",
                "name": "aggregatedExpenseCategoryFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v66/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6c8fb243238a31cdd26c42e47c27365",
    "id": null,
    "metadata": {},
    "name": "DetailsExpenseCategoryLoader_Query",
    "operationKind": "query",
    "text": "query DetailsExpenseCategoryLoader_Query(\n  $projectId: ID!\n  $phaseId: ID!\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $aggregateLevel: AggregateLevel!\n  $aggregate: FinancialAggregatedNumber!\n  $searchQuery: TaskSearchQueryType\n  $baselineRevenue: Boolean!\n  $baselineCost: Boolean!\n  $baselineProfit: Boolean!\n  $billableActualTimeAndExpenses: Boolean!\n  $actualCost: Boolean!\n  $actualProfit: Boolean!\n  $billablePlannedTimeAndExpenses: Boolean!\n  $plannedCost: Boolean!\n  $plannedProfit: Boolean!\n  $billableForecastTimeAndExpensesToComplete: Boolean!\n  $forecastCostToComplete: Boolean!\n  $forecastProfitToComplete: Boolean!\n  $billableTotalTimeAndExpensesAtCompletion: Boolean!\n  $totalCostAtCompletion: Boolean!\n  $totalProfitAtCompletion: Boolean!\n  $planVsBillableActualTimeAndExpenses: Boolean!\n  $planVsActualCost: Boolean!\n  $planVsActualProfit: Boolean!\n  $planVsTotalBillableTimeAndExpensesAtCompletion: Boolean!\n  $planVsTotalCostAtCompletion: Boolean!\n  $planVsTotalProfitAtCompletion: Boolean!\n  $baselineVsBillableActualTimeAndExpenses: Boolean!\n  $baselineVsActualCost: Boolean!\n  $baselineVsActualProfit: Boolean!\n  $baselineVsBillableTotalTimeAndExpensesAtCompletion: Boolean!\n  $baselineVsTotalCostAtCompletion: Boolean!\n  $baselineVsTotalProfitAtCompletion: Boolean!\n  $invoiced: Boolean!\n  $paid: Boolean!\n  $baselineMinutes: Boolean!\n  $baselineVsRegisteredMinutes: Boolean!\n  $baselineVsTotalTimeAtCompletion: Boolean!\n  $registeredMinutes: Boolean!\n  $scopeApprovedMinutes: Boolean!\n  $registeredVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsRegisteredMinutes: Boolean!\n  $forecastTimeToComplete: Boolean!\n  $totalTimeAtCompletion: Boolean!\n  $totalTimeAtCompletionVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsTotalTimeAtCompletion: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"details_expense_loader\")\n    ...DetailsExpenseCategoryLoader_viewer_4v8vw5\n    id\n  }\n}\n\nfragment DetailsExpenseCategoryLoader_viewer_4v8vw5 on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    rateCard {\n      currency\n      id\n    }\n    expenseCategoryFinancialBreakdown(phaseId: $phaseId, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true, filterRowsWithNoValues: true) {\n      breakdownType\n      expenseCategory {\n        id\n        name\n      }\n      financialNumbers {\n        baselineRevenue @include(if: $baselineRevenue)\n        baselineCost @include(if: $baselineCost)\n        baselineProfit @include(if: $baselineProfit)\n        billableActualTimeAndExpenses @include(if: $billableActualTimeAndExpenses)\n        actualCost @include(if: $actualCost)\n        actualProfit @include(if: $actualProfit)\n        billablePlannedTimeAndExpenses @include(if: $billablePlannedTimeAndExpenses)\n        plannedCost @include(if: $plannedCost)\n        plannedProfit @include(if: $plannedProfit)\n        billableForecastTimeAndExpensesToComplete @include(if: $billableForecastTimeAndExpensesToComplete)\n        forecastCostToComplete @include(if: $forecastCostToComplete)\n        forecastProfitToComplete @include(if: $forecastProfitToComplete)\n        billableTotalTimeAndExpensesAtCompletion @include(if: $billableTotalTimeAndExpensesAtCompletion)\n        totalCostAtCompletion @include(if: $totalCostAtCompletion)\n        totalProfitAtCompletion @include(if: $totalProfitAtCompletion)\n        planVsBillableActualTimeAndExpenses @include(if: $planVsBillableActualTimeAndExpenses)\n        planVsActualCost @include(if: $planVsActualCost)\n        planVsActualProfit @include(if: $planVsActualProfit)\n        planVsTotalBillableTimeAndExpensesAtCompletion @include(if: $planVsTotalBillableTimeAndExpensesAtCompletion)\n        planVsTotalCostAtCompletion @include(if: $planVsTotalCostAtCompletion)\n        planVsTotalProfitAtCompletion @include(if: $planVsTotalProfitAtCompletion)\n        baselineVsBillableActualTimeAndExpenses @include(if: $baselineVsBillableActualTimeAndExpenses)\n        baselineVsActualCost @include(if: $baselineVsActualCost)\n        baselineVsActualProfit @include(if: $baselineVsActualProfit)\n        baselineVsBillableTotalTimeAndExpensesAtCompletion @include(if: $baselineVsBillableTotalTimeAndExpensesAtCompletion)\n        baselineVsTotalCostAtCompletion @include(if: $baselineVsTotalCostAtCompletion)\n        baselineVsTotalProfitAtCompletion @include(if: $baselineVsTotalProfitAtCompletion)\n        invoiced @include(if: $invoiced)\n        paid @include(if: $paid)\n        baselineMinutes @include(if: $baselineMinutes)\n        baselineVsRegisteredMinutes @include(if: $baselineVsRegisteredMinutes)\n        baselineVsTotalTimeAtCompletion @include(if: $baselineVsTotalTimeAtCompletion)\n        registeredMinutes @include(if: $registeredMinutes)\n        scopeApprovedMinutes @include(if: $scopeApprovedMinutes)\n        registeredVsScopeApprovedMinutes @include(if: $registeredVsScopeApprovedMinutes)\n        scopeApprovedVsRegisteredMinutes @include(if: $scopeApprovedVsRegisteredMinutes)\n        forecastTimeToComplete @include(if: $forecastTimeToComplete)\n        totalTimeAtCompletion @include(if: $totalTimeAtCompletion)\n        totalTimeAtCompletionVsScopeApprovedMinutes @include(if: $totalTimeAtCompletionVsScopeApprovedMinutes)\n        scopeApprovedVsTotalTimeAtCompletion @include(if: $scopeApprovedVsTotalTimeAtCompletion)\n      }\n    }\n    aggregatedExpenseCategoryFinancialBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, phaseId: $phaseId, aggregateLevel: $aggregateLevel, aggregates: [$aggregate], searchQuery: $searchQuery, convertToProjectCurrency: true, filterRowsWithNoValues: true) {\n      breakdownType\n      expenseCategory {\n        id\n        name\n      }\n      aggregatedFinancialNumbers\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3827742e3ada7a3f6dcd8b5968afdaae";

export default node;
